export const OFF_BALANCE_LIABILITIES_TABLE_ARIA_LABEL = 'Позабалансові зобов’язання';
export const OFF_BALANCE_LIABILITIES_TABLE_MIN_WIDTH = 1540;
export const OFF_BALANCE_LIABILITIES_DATE_COLUMN_INDEXES = [7, 8] as const;
export const OFF_BALANCE_LIABILITIES_TABLE_HEADERS = [
  'Контрагент / боржник',
  'Кредитор / обслуговуючий банк',
  'Тип зобов’язання',
  'Код валюти',
  'Ліміт, тис. од.',
  'Обсяг фактичних зобов’язань, тис. од.',
  'Процентна ставка, %',
  'Дата відкриття',
  'Дата закінчення',
] as const;
export const OFF_BALANCE_LIABILITIES_TABLE_COLUMN_WIDTHS = [
  '12%',
  '18%',
  '13%',
  '7%',
  '11%',
  '13%',
  '11%',
  '8%',
  '8%',
] as const;
